import type { SVGProps } from "react";

export function MoreVertIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="5"
        r="2"
        fill="currentColor"
      />
      <circle
        cx="12"
        cy="12"
        r="2"
        fill="currentColor"
      />
      <circle
        cx="12"
        cy="19"
        r="2"
        fill="currentColor"
      />
    </svg>
  );
}
